export default __webpack_public_path__ + "static/media/google-pay.851fc933.png";